import { FONTS, COLORS } from '../../constants';

const styles = {
  root: {
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
    backgroundColor: COLORS.GREY_DARK,
    minHeight: '100vh',
  },
};

export default styles;
